type ArgType =
  | (string | null | undefined)
  | (string | boolean)
  | { [key: string]: boolean }
  | (string | null | undefined)[]

export function cls(...args: ArgType[]) {
  let classNames: string[] = []

  args.forEach((arg: ArgType) => {
    if (typeof arg === 'boolean') {
      return
    } else if (typeof arg === 'string') {
      classNames.push(arg as string)
    } else if (arg instanceof Object) {
      classNames.push(
        ...Object.keys(arg).filter(
          (key) => !!(arg as { [key: string]: boolean })[key]
        )
      )
    } else if (Array.isArray(arg)) {
      classNames.push(...(arg as string[]).filter((v) => v))
    }
  })
  return classNames
    .filter((v) => v.trim())
    .join(' ')
    .replace(/\n +/g, ' ')
    .trim()
}
